import * as tslib_1 from "tslib";
import { OnInit, EventEmitter, Injector } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { NgbModal } from '../../../../../../node_modules/@ng-bootstrap/ng-bootstrap';
import { FileViewerComponent } from '../file-viewer/file-viewer.component';
import { UserService } from '../../../services/user.service';
import { VsFileItem } from '../../file-upload/models/file-item';
import { VsFileUploadService } from '../services/file-upload.service';
import { DialogService } from 'primeng/primeng';
import { DocumentViewerComponent } from '../document-viewer/document-viewer.component';
import { FileType } from '../../../../dapfood/common/constant';
import { ComponentBase } from '../../../classes/base/component-base';
export class VsFsListFileComponent extends ComponentBase {
    constructor(_injector, _fileService, ngbModal, _userService, dialogService) {
        super();
        this._injector = _injector;
        this._fileService = _fileService;
        this.ngbModal = ngbModal;
        this._userService = _userService;
        this.dialogService = dialogService;
        this.files = [];
        this.disabled = false;
        this.ids = [];
        this.linkView = '';
        this.selectedFile = new VsFileItem();
        this.currentIds = '';
        this.isMngFile = false;
        this.viewOnly = false;
        this.isSingleFile = false;
        this.onUploaded = new EventEmitter();
        this.onRemoved = new EventEmitter();
        this.onClick = new EventEmitter();
        this.onSelectItem = new EventEmitter();
        this.onChangeControl = (obj) => { };
        this.onTouched = () => { };
    }
    ngOnInit() {
        this.userId = this._userService.getBasicUserInfo().userId;
    }
    writeValue(obj) {
        if (obj) {
            this.files = obj;
        }
    }
    registerOnChange(fn) {
        this.onChangeControl = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    openFile(item) {
    }
    deleteFile(item) {
        if (item.isFolder === true) {
            this._fileService.deleteFolder(this.userId, item.id);
            const fileToRemove = this.files.findIndex(x => x.fileName === item.fileName);
            this.files.splice(fileToRemove, 1);
        }
        else {
            this._fileService.deleteFile(item);
            const fileToRemove = this.files.findIndex(x => x.fileName === item.fileName);
            this.files.splice(fileToRemove, 1);
            this.onChangeControl(this.files);
            this.onRemoved.next(item);
        }
    }
    deleteFileTemp(item) {
        if (item.isFolder === true) {
            const fileToRemove = this.files.findIndex(x => x.fileName === item.fileName);
            this.files.splice(fileToRemove, 1);
        }
        else {
            const fileToRemove = this.files.findIndex(x => x.fileName === item.fileName);
            this.files.splice(fileToRemove, 1);
            this.onChangeControl(this.files);
            this.onRemoved.next(item);
        }
    }
    viewFile(item) {
        if (item.type == FileType.Image || item.type == FileType.Video) {
            this.ref = this.dialogService.open(FileViewerComponent, {
                data: {
                    file: item,
                },
                showHeader: false,
                width: '100%',
                height: 'calc(100vh)',
                styleClass: "vs-modal",
                contentStyle: { 'overflow': 'auto', 'position': 'relative' },
                baseZIndex: 1100,
                closeOnEscape: true,
            });
        }
        else {
            this.ref = this.dialogService.open(DocumentViewerComponent, {
                data: item,
                showHeader: true,
                header: item.fileName,
                width: '100%',
                height: 'calc(100vh - 0px)',
                styleClass: "vs-modal vs-file-viewer",
                contentStyle: { 'overflow': 'auto' },
                baseZIndex: 1100,
                closeOnEscape: true
            });
        }
    }
    onItemClick(item) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.selectedFile = new VsFileItem();
            if (item.isFolder === true) {
                this.onChangeControl(this.files);
                this.onClick.next(item);
            }
            else {
                this.viewFile(item);
            }
        });
    }
    checkItem(item) {
        if (this.isSingleFile) {
            this.files.forEach(element => {
                if (element.id !== item.id) {
                    element.checked = false;
                }
            });
            if (item.checked) {
                this.ids = [];
                this.ids.push(item.id);
                item.checked = true;
            }
            else {
                this.ids.splice(this.ids.indexOf(item.id), 1);
                item.checked = false;
            }
            this.onChangeControl(this.ids);
            this.onSelectItem.next(this.ids + '');
        }
        else {
            this.ids = this.currentIds.split(',').filter(s => s !== '');
            if (item.checked) {
                // Kiểm tra nếu Id chưa có trong currentIds thì bổ sung
                if (this.currentIds.indexOf(item.id + ',') < 0 && this.currentIds.indexOf(',' + item.id) < 0) {
                    this.ids.push(item.id);
                    item.checked = true;
                    this.onSelectItem.next(this.ids + ',');
                }
            }
            else {
                // Kiểm tra nếu Id có trong currentIds thì remove để xóa
                this.currentIds = this.currentIds.replace(item.id + ',', '');
                this.currentIds = this.currentIds.replace(',' + item.id, '');
                this.ids.splice(this.ids.indexOf(item.id), 1);
                item.checked = false;
                this.onSelectItem.next(this.currentIds);
            }
            this.onChangeControl(this.ids);
        }
        // alert(this.ids + this.currentIds);
    }
    onClose() {
        this.modalReference.close();
    }
}
